const l = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.763 23.411a1.75 1.75 0 0 0 2.474 0l10.174-10.174a1.75 1.75 0 0 0 0-2.475L13.237.588a1.75 1.75 0 0 0-2.474 0L.589 10.762a1.75 1.75 0 0 0 0 2.475l10.174 10.174Z" clip-rule="evenodd"></path></svg>';
export {
  l as default
};
